import FeaturedQuiz from "./FeaturedQuiz";
import Sidebar from "./Sidebar";

const Container: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row container mx-auto p-8">
      <div className="lg:w-2/3">
        <FeaturedQuiz />
      </div>
      <div className="lg:w-1/3">
        <Sidebar />
      </div>
    </div>
  );
};

export default Container;
